<span [class]="badgeClass">
  @if (dispCheckbox) {
    <span class="hc-badge__checkbox"></span>
  }
  @if (dispIcon) {
    <span class="hc-badge__icon">
      <ng-content select="[badgeIcon]"></ng-content>
    </span>
  }
  <span class="hc-badge__label">
    <ng-content></ng-content>
  </span>
</span>
